<template>
  <div class="password-confirm-input">
    <div class="form-group" v-bind:class="{ 'has-feedback' : field.dirty }">
      <label v-bind:for="field.name" class="col-sm-4 control-label has-icon has-icon-password">{{ field.label }} <span v-if="field.required" class="required">*</span></label>
      <div class="col-sm-8">
        <input v-bind:id="field.name" class="form-control" type="password" v-model="field.value" v-bind:name="field.name"/>
        <span class="form-validation-error" v-show="!isLength && field.dirty">{{ field.label }} needs to be at least 6 characters long.</span>
        <span class="fa fa-check form-control-feedback form-control-feedback-success" v-show="field.valid && field.dirty"></span>
        <span class="fa fa-remove form-control-feedback form-control-feedback-error" v-show="!field.valid && field.dirty"></span>
      </div>
    </div>
    <div class="form-group">
      <label class="col-sm-4 control-label has-icon has-icon-password">Confirm {{ field.label }}</label>
      <div class="col-sm-8">
        <input type="password" class="form-control" v-model="confirmValue"/>
        <span class="form-validation-error" v-show="!isMatch && field.dirty && confirmValue.length > 0">Passwords do not match.</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'passwordConfirmInput',
  props: {
    field: {
      type: Object,
      default () {
        return {
          value: '',
          valid: false,
          dirty: false
        }
      }
    }
  },
  data () {
    return {
      confirmValue: '',
      isLength: false,
      isMatch: false
    }
  },
  watch: {
    'field.value': function (newVal, oldVal) {
      if (oldVal === '') this.field.dirty = true
      this.isLength = this.field.valid = newVal.length > 5
      this.isMatch = this.field.valid = this.field.value === this.confirmValue
    },
    'confirmValue': function (newVal, oldVal) {
      if (oldVal === '') this.field.dirty = true
      this.isLength = this.field.valid = newVal.length > 5
      this.isMatch = this.field.valid = this.field.value === this.confirmValue
    }
  }
}
</script>



// WEBPACK FOOTER //
// PasswordConfirmInput.vue?3b2f0ba8